import SubscriptionListSelfcare from "../../Components/LightWeightCustomer/SubscriptionListingSelfcare";

export default function SelfcareSubscriptionListing(){
    return(
        <SubscriptionListSelfcare/>
    )
}